export const InfoBoxData = [
    {
        name: "Cancelled - Pictorial",
        description: "Cancelled pictorial describes a stamp which has been specially cancelled with a pictorial date stamp."
    },
    {
        name: "Cancelled - Standard",
        description: "Cancelled standard describes a stamp cancelled with a standard metal date stamp. "
    },
    {
        name: "Commemorative",
        description: "Commemorative stamps are issued to commemorate an event, person or anniversary."
    },
    {
        name: "Definitive",
        description: "Definitive stamps are the standard postage stamps available over a period of five to seven years."
    },
    {
        name: "Mint",
        description: "A mint stamp is not affixed to an envelope and is not cancelled. It is unused and in its original state of issue."
    },
    {
        name: "Serviced - Pictorial",
        description: "Serviced pictorial describes a First Day Cover which has been specially cancelled with a pictorial date stamp. "
    },
    {
        name: "Unserviced",
        description: "Unserviced describes a First Day Cover where no stamp or cancellation has been applied to the envelope."
    }
];
